import { Content } from "pdfmake/interfaces";
import { RegisteredChipDetailResponse } from "@app/shared/models/chip-details.model";
import { formatDateForSignature } from "./date-signature-format";

export function pdfRenderConfirmationSvg(registrationDetails: RegisteredChipDetailResponse | undefined): Content[] {
    return registrationDetails ? [
        {
            columns: [
                {
                    svg: `
                        <svg transform="rotate(-90deg)" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
                            <style>
                                .small {
                                    font-size: 10px;
                                }
                            </style>
                            <text
                                x="0"
                                y="15"
                                text-anchor="left"
                                class="small"
                                fill="black">
                                Firmosur elektronikisht nga
                            </text>
                                <text
                                x="0"
                                y="27"
                                class="small"
                                fill="black">
                                REGJISTRI KOMBËTAR I KAFSHËVE SHTËPIAKE
                            </text>
                            <text
                                x="0"
                                y="39"
                                class="small"
                                text-anchor="left"
                                fill="black">
                                ${formatDateForSignature(registrationDetails.date)}
                            </text>
                        </svg>
                    `,
                    absolutePosition: { x: 0, y: 820 },
                },
            ]
        },
    ] : [];
}
